<template>
  <v-dialog persistent v-model="dialog" width="320">
    <v-card>
      <v-card-title class="title"
        >Antes de incluir arquivos,<br />{{ message }}</v-card-title
      >
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="default" text @click="closeDialog">Cancelar</v-btn>
        <v-btn color="secondary" text @click="saveConfirm">
          {{ buttonLabel }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialogChild: {
      required: true,
      type: Boolean,
    },
    projectId: {
      required: false,
      type: Number,
      default: null,
    },
  },

  data: () => ({}),

  computed: {
    dialog() {
      return this.dialogChild;
    },
    message() {
      return this.projectId ? 'atualize o projeto.' : 'salve o projeto.';
    },
    buttonLabel() {
      return this.projectId ? 'Atualizar' : 'Salvar';
    },
  },

  methods: {
    closeDialog() {
      this.$emit('closeChild');
    },

    saveConfirm() {
      this.$emit('confirmChild');
    },
  },
};
</script>
